module.exports = __webpack_public_path__ + "img/itjcywlc.e9420231.svg";